'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var utils = require('../lib/utils');
var loadWrapper = require('../lib/loadWrapper');

var Orion = {};
var pageEvents = [];
var trackEvents = [];

Orion._detectBrowserAndGenParam = function () {
  if (!Orion._msieVersionFrom(navigator.userAgent)) return '';
  return '?seed=' + new Date().getTime();
};

Orion._msieVersionFrom = function (userAgent) {
  return (userAgent || '').match(/MSIE (\d+\.\d+);/);
};

Orion.windowLoaded = function (callback) {
  if (document.readyState === 'complete') return callback();
  utils._on(window, 'load', callback, false, 300);
};

Orion.loadScript = function (url, callback) {
  loadWrapper._load(url + Orion._detectBrowserAndGenParam(), callback);
};

Orion.clearQueue = function () {
  if (!window.orion || !window.orion.loaded) {
    return;
  }
  while (pageEvents.length > 0) {
    var pageEvent = pageEvents.shift();
    window.orion.page(pageEvent.pageType, pageEvent.payload);
  }

  while (trackEvents.length > 0) {
    var trackEvent = trackEvents.shift();
    window.orion.track(trackEvent.event, trackEvent.payload);
  }
};

Orion.initialise = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (window.orion && window.orion.loaded) {
    // This function should be called only once
    return;
  }
  var env = config.env === 'production' ? config.env : 'staging';
  var orionURL = 'https://d3ojfshdw1hp8b.cloudfront.net/' + env + '/v5/orion.min.js';

  Orion.loadScript(orionURL, function (err) {
    if (err) {
      return err;
    }

    Orion.windowLoaded(function () {
      if (!window.orion) {
        return;
      }

      var orionConfig = {
        environment: config.env,
        orion: {
          service: config.service,
          useCurrentDomain: config.lb
        },
        schemaVersions: config.schemaVersions || {},
        organisation: config.organisation
      };
      window.orion.initialise(orionConfig);

      if (window.orion.loaded) {
        Orion.clearQueue();
      }
    });
  });
};

Orion._safePayload = function (payload) {
  if (payload) {
    try {
      return JSON.parse(utils._stringify(payload));
    } catch (e) {
      if (process.env.NODE_ENV !== 'production') console.warn('Orion could not clone', payload, e);
      Orion.track('error', e);
    }
  }
  return {};
};

Orion.page = function (system, payload) {
  var safePayload = Orion._safePayload(payload);
  try {
    safePayload.page_type = safePayload.interstitial_page_type || safePayload.page_type;
    delete safePayload.interstitial_page_type;
    safePayload.system = system;
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(system, payload, 'was a', typeof safePayload === 'undefined' ? 'undefined' : _typeof(safePayload), 'this errored', err);
    }
  }
  Orion._pushPageEvent({ pageType: safePayload.page_type, payload: safePayload });
  Orion.clearQueue();
};

Orion.track = function (event, payload) {
  var safePayload = Orion._safePayload(payload);
  trackEvents.push({ event: event, payload: safePayload });
  return Orion.clearQueue();
};

Orion.error = function (payload) {
  Orion.track('error', payload);
};

Orion.inline = function (event, payload) {
  if (payload) {
    payload = Orion._safePayload(payload);
    if (event !== 'view') {
      // @todo remove all trace of action: from tracker and flatten payload
      if (!payload.action) payload = { action: payload };
    }
    payload.page_action_id = true;
  }

  Orion.track(event, payload);
};

Orion._pushPageEvent = function (event) {
  if (event) pageEvents.push(event);
};

module.exports = Orion;